import { defineMessage } from 'react-intl';

export const recentSectionMessage = defineMessage({
  id: 'stations.selector.recent',
  defaultMessage: 'Recientes',
});

export const favoritesSectionMessage = defineMessage({
  id: 'stations.selector.favorites',
  defaultMessage: 'Favoritas',
});

export const myStationsSectionMessage = defineMessage({
  id: 'stations.selector.myStations',
  defaultMessage: 'Mis emisoras',
});

export const sharedStationsSectionMessage = defineMessage({
  id: 'stations.selector.shared',
  defaultMessage: 'Emisoras externas',
});

export const sharedGroupSectionMessage = defineMessage({
  id: 'stations.selector.sharedGroup',
  defaultMessage: '{name}',
});
